<template lang="pug">
    model-data-table(
        loading-text="Cargando comisiones..."
        no-data-text="Sin comisiones."
        no-search
        ref="table"
        remind-key='sl-commission-list'
        v-bind="tableProps"
        @detail="submitShow"
        @remove="submitRemove"
        :no-detail="!$can('VIEW_DETAIL_COMMISSION')"
        :no-remove="!$can('DELETE_COMMISSION')"
        )
</template>

<script>
//
import { mapActions, mapState } from 'vuex'
//
import { ModelDataTable } from '@/components/reusable_components/next'
import CommissionService from '@/services/api/commission'
import MdlCommission from '../../models/Sale/SlCommission'
//
import CommissionsFilters from './filters'
import CommissionsHeaders from './headers'
//
export default {
    components: {
        'model-data-table': ModelDataTable,
    },
    computed: {
        ...mapState('SnackbarModalModule', {
            responseConfirm: 'responseConfirm',
        }),
        tableProps() {
            return {
                service: MdlCommission,
                headers: this.headers,
                filters: this.filters,
            }
        },
    },
    data() {
        return {
            filters: CommissionsFilters,
            headers: CommissionsHeaders,
            selected: null,
            selectedId: null,
        }
    },
    name: 'commission-list',
    methods: {
        ...mapActions('MenuesModule', {
            // setItemsTopBar: 'setItemsTopBar',
            setTitleTopBar: 'setTitleTopBar',
        }),
        ...mapActions('SnackbarModalModule', {
            initSnackbar: 'initSnackbar',
            hideSnack: 'hideSnack',
            resetSnackbarState: 'resetSnackbarState',
            setMessageConfirmSnack: 'setMessageConfirmSnack',
        }),
        submitShow: function(event) {
            this.$router.push(`/commissions/${event.item.id}`)
        },
        responseRemove(response) {
            switch (response.status) {
                case 'success':
                    this.resetSnackbarState()
                    this.showSnackbar(
                        'success',
                        'Éxito.',
                        'Comisión eliminada.'
                    )
                    this.$refs.table.refresh()
                    break
                default:
                    this.resetSnackbarState()
                    this.showSnackbar(
                        'error',
                        'Error.',
                        response.message || response.error
                    )
                    break
            }
        },
        setSelectedId(id) {
            this.selectedId = id
        },
        showSnackbar(type, title, message) {
            this.initSnackbar(this.fillSnack(type, title, message))
        },
        submitCreate() {
            this.$router.push('commissions/create')
        },
        submitRemove(event) {
            this.resetSnackbarState()
            this.setMessageConfirmSnack('eliminar comisión')
            this.showSnackbar('warning', '¿Deseas eliminar la comisión?')
            this.setSelectedId(event.item.id)
        },
        //- create button with new components
        // create() {
        //     this.$router.push({ name: 'commission-create' })
        // },
    },
    beforeMount() {
        this.setTitleTopBar('Listado de comisiones')
        this.$setItemsTopBar([
            {
                text: 'crear comisión',
                icon: 'add',
                can: 'CREATE_COMMISSION',
                action: () => this.$router.push('/commissions/create'),
            },
        ])
    },
    watch: {
        async loading() {},
        async responseConfirm(type) {
            switch (type) {
                case 'eliminar comisión':
                    this.responseRemove(
                        await CommissionService.remove(this.selectedId)
                    )
                    break
            }
        },
    },
    beforeRouteEnter(to, from, next) {
        next(ctx => {
            if (!ctx.$can('VIEW_ALL_COMMISSION')) ctx.$router.push('/')
        })
    },
}
</script>
